const CSS_DURATION_CACHE = new Map<string, number>();

export const parseCSSVariableDuration = (
  variableName: string,
  fallback: number,
): number => {
  const cacheKey = variableName;

  if (CSS_DURATION_CACHE.has(cacheKey)) {
    return CSS_DURATION_CACHE.get(cacheKey)!;
  }

  if (typeof window === 'undefined' || !document.documentElement) {
    return fallback;
  }

  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(variableName)
    .trim();

  if (!value) {
    return fallback;
  }

  const duration = value.endsWith('ms')
    ? parseFloat(value) || fallback
    : value.endsWith('s')
      ? parseFloat(value) * 1000 || fallback
      : parseFloat(value) || fallback;

  CSS_DURATION_CACHE.set(cacheKey, duration);

  return duration;
};
